import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzResultModule } from 'ng-zorro-antd/result';
import { NzIconModule } from 'ng-zorro-antd/icon';

@Component({
  selector: 'app-maintenance',
  imports: [CommonModule, NzResultModule, NzIconModule],
  templateUrl: './maintenance.component.html',
  styleUrl: './maintenance.component.scss',
  standalone: true,
})
export class MaintenanceComponent {}
